"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontsLink = void 0;
var _createStaticAssetUrl = require("../utils/createStaticAssetUrl");
var _jsxRuntime = require("react/jsx-runtime");
const FONT_ASSETS = {
  SansOri: {
    cssFile: 'font-sans-ori.css',
    preloadedFonts: ['sans-regular.woff2']
  },
  SansCondensedOri: {
    cssFile: 'font-sans-condensed-ori.css'
  }
};
const FontsLink = ({
  version,
  staticStorageUrl
}) => {
  const links = [];
  Object.values(FONT_ASSETS).forEach(({
    cssFile,
    preloadedFonts
  }) => {
    links.push({
      key: `${cssFile}-preload`,
      rel: 'preload',
      as: 'style',
      crossOrigin: 'anonymous',
      href: (0, _createStaticAssetUrl.createStaticAssetUrl)(staticStorageUrl, version, {
        assetName: cssFile,
        blobPrefix: 'fonts'
      })
    });
    preloadedFonts?.forEach(fontFileName => {
      links.push({
        key: `${cssFile}-${fontFileName}`,
        rel: 'preload',
        as: 'font',
        crossOrigin: 'anonymous',
        href: (0, _createStaticAssetUrl.createStaticAssetUrl)(staticStorageUrl, version, {
          assetName: `fonts/${fontFileName}`,
          blobPrefix: 'fonts'
        })
      });
    });
    links.push({
      key: `${cssFile}-file`,
      rel: 'stylesheet',
      crossOrigin: 'anonymous',
      href: (0, _createStaticAssetUrl.createStaticAssetUrl)(staticStorageUrl, version, {
        assetName: cssFile,
        blobPrefix: 'fonts'
      })
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: links.map(({
      key,
      ...props
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      ...props
    }, key))
  });
};
exports.FontsLink = FontsLink;
